module.exports = __webpack_public_path__ + "img/samsung.db5287cb.png";